import React from "react";
import { derive } from "../admin/recordDerive";

export function ProductivityDrill({ title, items, recordsById, onBack }) {
  return (
    <div className="pdrill">
      <div className="pdrill-bar">
        <button className="btn btn-ghost pdrill-back" onClick={onBack}>← Back</button>
        <div className="pdrill-title">
          <h2>{title}</h2>
          <span>{items.length} record{items.length > 1 ? "s" : ""}</span>
        </div>
      </div>
      <div className="pdrill-list">
        {items.map((e, i) => <DrillRecord key={i} rec={recordsById[e.recordId]} e={e} />)}
      </div>
    </div>
  );
}

function DrillRecord({ rec, e }) {
  const d = rec ? derive(rec) : {};
  const fields = rec ? [
    ["PID (MRN)", rec.mrn], ["Unique ID", rec.uniqueId],
    ["Clinic Location", d.clinic], ["Location Code", d.locationCode], ["Group", rec.productionGroup || d.location],
    ["Order", d.orders], ["OrderMD", d.orderMD], ["Order Date", d.orderDate],
    ["RTC Date", d.rtcDate], ["RTC Priority", d.rtcPriority], ["Urgent / Routine", d.urgentRoutine], ["Clinic Priority", d.clinicPriority],
    ["Payor / IPA", d.insurance], ["Portal", d.portal],
    ["CPTs", rec.submittedCpts], ["ICDs", rec.submittedIcds],
    ["Current status", rec.paStatus], ["Inbox", rec.inboxValue],
    ["Authorization number", rec.authNumber], ["Request number", rec.requestNumber],
    ["Fax number", rec.faxNumber], ["Phone number", rec.phoneNumber],
  ] : [];
  return (
    <div className="pdrill-card">
      <div className="pdrill-card-h">
        <div className="pdrill-card-title"><b>PID {e.mrn}</b><span>{e.order || "—"}</span></div>
        <span className="pdrill-worked">Worked by <b>{e.user || "—"}</b>{e.dateStr ? <> on <b>{e.dateStr}</b></> : null}</span>
      </div>

      <div className="pdrill-round">
        {e.status && <span className="pdrill-chip st">Status: {e.status}</span>}
        {e.statusDate && <span className="pdrill-chip">Status date: {e.statusDate}</span>}
        {e.issueType && <span className="pdrill-chip issue">{e.issueType} issue</span>}
      </div>
      {(e.reason || e.remarks || e.issueReason) && (
        <div className="pdrill-notes">
          {e.issueReason && <div className="pdrill-kv"><span>Issue reason</span><b>{e.issueReason}</b></div>}
          {e.reason && <div className="pdrill-kv"><span>Reason</span><b>{e.reason}</b></div>}
          {e.remarks && <div className="pdrill-kv"><span>Remarks</span><b>{e.remarks}</b></div>}
        </div>
      )}

      {rec ? (
        <>
          <div className="pdrill-sec-label">Full record</div>
          <div className="fit-grid pdrill-fields">
            {fields.filter(([, v]) => v).map(([k, v]) => (
              <div className="fit-cell" key={k}><span>{k}</span><b className={k === "Unique ID" ? "uid-wrap" : ""}>{v}</b></div>
            ))}
          </div>
        </>
      ) : <div className="pdrill-missing">Full record details are not available for this entry.</div>}
    </div>
  );
}